/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Mon, Jul 19th 2021, 9:02:38 pm
 *
 * *****************************************************
 */

export const DEFAULT = '/';
export const SIGN_IN = '/sign-in';
export const VERIFY_EMAIL = '/verify/email';
export const SELECT_WORKSPACE = '/select-workspace';
export const GET_STARTED_NEW = '/get-started/new';
export const GET_STARTED_CONFIRM_EMAIL = '/get-started/confirm-email';
export const CREATE_WORKSPACE = '/create-workspace';
export const SUCCESS_DELETE_WORKSPACE = '/workspace-not-available/:encodedWorkspaceName';
